import React, { Fragment, PureComponent, ReactNode, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Fuse from 'fuse.js';
import { getPtFullName, Patient } from '../store/types/patient';
import {
    getAllPatients,
    getAllPatientsWithFollowupOn,
    getDoc,
    getPtColumns,
    getSelectedClinicId,
    getVisitById,
    getVisitByIds,
    getPtCount,
    setSelectedClinicId,
    getMyClinics,
    amIDoctor,
    getDoctorSelectorList,
} from '../store/idbHandler';
import LeftBar from '../components/common/NavBar';
import { connect, useDispatch, useSelector } from 'react-redux';
import { initVisit } from '../store/actions/visit';
import {
    GO_TO_PRESCRIPTION_PAD,
    GO_TO_PATIENTS_DETAILS,
    GO_TO_ADD_NEW_PATIENT,
    GO_TO_ALL_PATIENTS,
    GO_TO_ABHA_DASHBOARD,
    GO_TO_APPOINTMENTS,
} from '../routes/paths';
import GoToAddPatientBt from '../components/common/GoToAddPateintBt';
import { Helmet } from 'react-helmet';
import { APWithOptionalpatient } from './Appointments';
import { NewPatientLocationState } from './NewPatient';
import { isCNRE, onAppointmentAction } from './AppointmentUtils';
import {
    addPatient,
    fetchActiveOrderUpdates,
    fetchPtDir,
    WithBEPatient,
} from '../store/actions/app';
import DashboardInviteCodePanel from '../components/common/DashboardInviteCodePanel';
import { AnimatePresence } from 'framer-motion';
import { GeniePtColumns, SREV2 } from '../api/pushGenie';
import { updatePtColumns } from '../store/actions/genie';
import { ABHA_IDS, DEFAULT_PT_COLUMNS, keyToLabel, MANDATE_PT_COLUMNS } from '../constants';
import { timeTrackStart, track } from '../tracking';
import { Actions } from '../store/actions';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../store/reducers';
import { AppointmentsResponse, fetchTodayQueue } from '../api/fetchAppointmentsV2';
import { Button, Radio, Space } from 'antd';
import { getAddPDForms, isDoctor } from './utils';
import moment, { Moment } from 'moment';
import { CustomDatePicker } from '../components/common/DatePicker';
import { downloadPtDir, showDialog } from '../store/actions/prescriptionPad';
import { dispatch } from '../bridge/events/dispatch';
import AllPatientsEmptyView from './AllPatientsEmptyView';
import MergeProfileDialog from '../components/common/MergeProfileDialog';
import { HealthWeekStrip } from '../components/common/HealthWeek';
import AllPatientList, { MultiDocBookAptHandlerProps } from './AllPatientsList';
import AllPtTableHeader from './AllPtTableHeader';
import NewHeaderComponent from '../components/common/NewHeaderComponent';
import ClinicSelector from '../components/common/ClinicSelector';
import { fuseConfig, indexAllPatients } from './allPatientsIndex';
import { getGenieSetting } from '../store/selectors/session';
import { DividerIcon } from '../components/common/Icons';
import DoctorReferralAllPatient from '../components/prescriptionPad/leftPanel/DoctorReferralAllPatient';
import SlotModal from '../components/appointment/slot-modal';
import { Appointment } from '../api/fetchAppointmentById';
import { getAclViewClassName } from '../restrictions/utils';
import CreateABHAModalSDK from '../components/abha/CreateABHAModalSdk';
import { PurchaseEkaCreditsStrip } from './MyKhata';
import NewSignInStrip from '../components/common/NewSignInStrip';

const ALL_PATIENTS_INPUT_FIELD = 'ALL_PATIENTS_INPUT_FIELD';

const LoadingView = () => {
    return (
        <div className="space-y-16">
            {Array.from(Array(10)).map(() => (
                <div className="flex items-center justify-between w-full">
                    <div className="shine h-58 w-56" />
                    <div style={{ width: 330 }} className="shine h-58" />
                    <div style={{ width: 130 }} className="shine h-58 w-15p" />
                    <div style={{ width: 130 }} className="shine h-58 w-15p" />
                    <div style={{ width: 130 }} className="shine h-58 w-15p" />
                    <div style={{ width: 130 }} className="shine h-58 w-15p" />
                </div>
            ))}
        </div>
    );
};
type ListMode = 'quick' | 'full' | 'y-followup' | 't-followup' | 'custom-followup';

type State = {
    allPatients: Patient[];
    searchInput: string;
    referPt?: Patient;
    createAbhaPatient?: Patient;
    isLoading: boolean;
    isApptApiLoading: boolean;
    todayAppointments?: APWithOptionalpatient[];
    tableConfigVisible?: boolean;
    columns: { key: string; label: string }[];
    onAppPtsCount?: number;
    mode: ListMode;
    abhaFilterType?: 'present' | 'absent';
    referredFilterType?: 'referred';
    dates?: [Moment, Moment];
    allPtCount?: number;
    mergePtModal: boolean;
    activeLinkAbhaPatient?: Patient;
    refreshDocProfile?: string;
    abhaPtsNos?: number;
    ptsWithNoLinkedRecords?: number;
    bookAptModal: BookAptModalState;
};

export type BookAptModalState =
    | {
          docId: string;
          show: true;
          clinicId: string;
          ptId: string;
      }
    | { docId?: string; show: false; clinicId?: string; ptId?: string };

type RouterProps = {
    cId: string;
};

interface Props extends RouteComponentProps<RouterProps> {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    refreshAllPatients?: boolean;
    isHealthWeekDoctorFlag?: boolean;
    isAbdm: boolean;
    isMilestonesEnabled: boolean;
}

class AllPatientsComponent extends PureComponent<Props, State> {
    patientsFuse = new Fuse([] as Patient[], fuseConfig);
    tDate = new Date().toDateString();
    polling?: NodeJS.Timeout = undefined;
    POLL_INTERVAL_MS = 10 * 1000;
    PAGE_SIZE = 100;
    doc = getDoc();
    clinics = this.doc?.profile.professional.clinics;
    announcementUrl = `https://eka.frill.co/embed/widget/c16f239b-65b4-42d7-a1c1-3a994b15d4a6?user=${encodeURIComponent(
        JSON.stringify({
            name: [this.doc?.profile.personal.name.f, this.doc?.profile.personal.name.l]
                .filter(Boolean)
                .join(' '),
            email: `${this.doc?._id}@eka.do`,
        }),
    )}`;

    state: State = {
        allPatients: [],
        searchInput: '',
        isLoading: true,
        isApptApiLoading: true,
        columns: [],
        mode: 'quick',
        mergePtModal: false,
        refreshDocProfile: 'false',
        bookAptModal: {
            show: false,
        },
    };

    onModeChange = async (mode: ListMode): Promise<void> => {
        return new Promise((resolve, reject) => {
            timeTrackStart('AllPtPageDbCall');
            console.time('AllPtPageDbCall');
            this.setState({ isLoading: true });
            let p: Promise<Patient[] | undefined>;
            if (mode === 'quick' || mode === 'full') {
                const allPtWithTodaysFollowUp = getAllPatientsWithFollowupOn(
                    new Date(moment().toISOString()),
                );
                const allPt = getAllPatients(mode === 'quick' ? 500 : Number.MAX_SAFE_INTEGER);
                // combine both and remove duplicates
                p = new Promise((resolve, reject) => {
                    Promise.all([allPt, allPtWithTodaysFollowUp])
                        .then((values) => {
                            const [allPt, allPtWithTodaysFollowUp] = values;
                            const allPtWithTodaysFollowUpIds = new Set(
                                allPtWithTodaysFollowUp?.map((t) => t.localId),
                            );
                            const combinedPts = allPtWithTodaysFollowUp || [];
                            allPt?.forEach((t) => {
                                if (!allPtWithTodaysFollowUpIds.has(t.localId)) {
                                    combinedPts.push(t);
                                }
                            });
                            resolve(combinedPts);
                        })
                        .catch(reject);
                });
            } else if (mode === 'custom-followup') {
                const { dates } = this.state;
                if (!dates || !dates[0] || !dates[1]) {
                    return;
                }
                p = getAllPatientsWithFollowupOn(
                    new Date(dates[0].toISOString()),
                    new Date(dates[1].toISOString()),
                );
            } else {
                let d = moment();
                switch (mode) {
                    case 'y-followup':
                        d = moment().add(-1, 'days');
                        break;
                }
                p = getAllPatientsWithFollowupOn(new Date(d.toISOString()));
            }
            Promise.all([p])
                .then((values) => {
                    console.timeEnd('AllPtPageDbCall');
                    track('AllPtPageDbCall', {
                        count: values[0]?.length.toString(),
                        mode,
                    });

                    const allPt = values[0]?.filter((t) => !t.archived);

                    this.setState({
                        allPatients: allPt || [],
                        isLoading: false,
                        mode,
                        dates: mode === 'custom-followup' ? this.state.dates : undefined,
                    });
                    resolve();
                })
                .catch(reject);
        });
    };

    componentDidMount = (): void => {
        this.onMount();
        document.getElementById(ALL_PATIENTS_INPUT_FIELD)?.focus();
        this.getAllAppointments();
        fetchActiveOrderUpdates();
    };

    componentDidUpdate(prevProps: Props): void {
        if (this.props.match.params.cId !== prevProps.match.params.cId) {
            this.hardRefresh();
        }

        if (this.props.refreshAllPatients !== prevProps.refreshAllPatients) {
            this.setState((prev) => {
                return {
                    ...prev,
                    refreshDocProfile: prev.refreshDocProfile === 'false' ? 'true' : 'false',
                };
            });
        }
    }

    hardRefresh = (): void => {
        this.setState({
            isApptApiLoading: true,
        });
        this.poll();
    };

    poll = (): void => {
        if (amIDoctor()) {
            window
                .refreshTodayAppts?.({ clinicId: this.props.match.params.cId })
                .then(() => {
                    this.queryTodaysAppts();
                })
                .catch((err) => console.error("Couldn't refresh today's appointments", err));

            this.queryTodaysAppts();
        }
    };

    getAllAppointments = (): void => {
        this.poll();
        this.polling = setInterval(this.poll, this.POLL_INTERVAL_MS);

        return;
    };

    componentWillUnmount = (): void => {
        if (this.polling) {
            clearInterval(this.polling);
        }
    };

    onPatientsDetails = (id: string): void => {
        this.props.history.push(GO_TO_PATIENTS_DETAILS(id, 'visit', ''));
    };

    onSearchChange = (input: string): void => {
        this.setState({
            searchInput: input,
        });
    };

    startVisit = (docid: string, p: Patient): void => {
        if (!this.props.match.params.cId) {
            return;
        }

        if (!p.personal.gender || !p.personal.name.f) {
            let age;
            if (p.personal.age?.dob) {
                const sp = p.personal.age.dob.split('-');
                if (sp.length === 3) {
                    age = {
                        dob: {
                            dd: sp[2],
                            mm: sp[1],
                            yyyy: sp[0],
                        },
                    };
                }
            } else {
                age = { age: p.personal.age?.value, month: p.personal.age?.month };
            }
            // go to new patient
            const s: NewPatientLocationState = {
                oid: p.id,
                name: p.personal.name.f + (p.personal.name.l ? ' ' + p.personal.name.f : ''),
                phoneNumber: p.personal.phone?.n,
                age: age,
            };
            this.props.history.push({
                pathname: GO_TO_ADD_NEW_PATIENT(this.props.match.params.cId),
                state: s,
            });

            return;
        }

        const onSuccess = (prescriptionId: string) => {
            this.props.history.push({
                pathname: GO_TO_PRESCRIPTION_PAD(prescriptionId, 'edit'),
            });
        };

        const initVisitAction = initVisit(
            {
                id: p.id,
                localId: p.localId,
                uuid: p.uuid,
                name: p.personal.name.f,
                phCode: p.personal.phone?.c,
                phoneNumber: p.personal.phone?.n,
                gender: p.personal.gender,
                age: p.personal.age,
                onApp: p.personal.onApp,
                formData: p.formData,
                abha: Array.isArray(p.abhaV2)
                    ? p.abhaV2?.find((abha) => abha.cId === this.props.match.params.cId)
                    : p?.abha,
                relations: p.relations,
            },
            docid,
            this.props.match.params.cId,
            undefined,
            onSuccess,
            undefined,
            { autoCopy: true },
        );
        track('Start_Visit', { from: 'All_pt' });
        initVisitAction && this.props.dispatch(initVisitAction);
    };

    navigateToVisit = (vId: string): void => {
        getVisitById(vId).then((v) => {
            if (v && v.patient.localId && v.prescriptionId) {
                this.props.history.push(GO_TO_PRESCRIPTION_PAD(v.prescriptionId, 'edit'));
            } else {
                console.error('Visit/data not found');
            }
        });
    };

    onReferADoc = (p: Patient): void => {
        this.setState({
            referPt: p,
        });
    };

    onCreateABHA = (p?: Patient): void => {
        this.setState({
            createAbhaPatient: p,
        });
    };

    onSendReceipt = (docid: string, p: Patient): void => {
        WithBEPatient<Patient>(
            p,
            async (bePt: Patient) => bePt,
        )(this.props.dispatch)
            .then(async (bePt) => {
                const updatedPt = bePt;
                if (p.id !== bePt.id) {
                    this.onMount();
                }

                if (updatedPt) {
                    dispatch({
                        type: 'BILLING_POPUP',
                        data: {
                            docid: docid,
                            uhid:
                                updatedPt.formData
                                    ?.find((fd) => fd.key === 'uhid')
                                    ?.value?.toString() || null,
                            patient: {
                                mobile: updatedPt.personal.phone?.n,
                                uuid: updatedPt.id as string,
                                fln: `${updatedPt.personal.name.f}${
                                    updatedPt.personal.name.l ? updatedPt.personal.name.l : ''
                                }`,
                                oid: updatedPt.id,
                            },
                            clinicId: this.props.match.params.cId,
                            source: 'all-patients',
                        },
                    });
                } else {
                    track('ERROR', { on: 'onSendReceipt', what: 'could not find patient by id' });
                }
            })
            .catch((e) => {
                track('ERROR', { on: 'onSendReceipt', what: 'idk', error: e.message });
                alert('Failed to send receipt + add to queue');
            });
    };

    onArchivePatient = (): void => {
        this.onMount();
    };

    closeReferalDialog = (): void => {
        this.setState({
            referPt: undefined,
        });
    };

    openTableConfig = (e?: React.MouseEvent<HTMLDivElement>): void => {
        e?.stopPropagation();
        e?.preventDefault();

        this.setState({
            tableConfigVisible: true,
        });

        track('TOGGLE_PT_COLUMNS_DIALOG', { visible: 'true' });
    };

    closeTableConfig = (columns?: GeniePtColumns): void => {
        this.setState({
            tableConfigVisible: false,
        });

        if (columns) {
            this.refreshColumns();
        }

        track('TOGGLE_PT_COLUMNS_DIALOG', { visible: 'false' });
    };

    closeAllDialogs = (): void => {
        this.setState({ tableConfigVisible: false });
    };

    refreshColumns = (): void => {
        this.setState({ isLoading: true });
        const c = [] as { key: string; label: string }[];
        getPtColumns()
            .then((columns) => {
                getAddPDForms()
                    .then((dForm) => {
                        [
                            ...MANDATE_PT_COLUMNS,
                            ...columns.filter((t) => !MANDATE_PT_COLUMNS.includes(t)),
                        ].forEach((item) => {
                            if (!this?.props?.isAbdm && item === ABHA_IDS) {
                                return;
                            }

                            if (DEFAULT_PT_COLUMNS.includes(item)) {
                                c.push({ key: item, label: keyToLabel(item) });
                            } else {
                                const df = dForm.find((t) => t.key === item);
                                df && c.push({ key: item, label: df?.label });
                            }
                        });

                        this.setState({ columns: c, isLoading: false });
                    })
                    .catch(console.error);
            })
            .catch(console.error);
        return;
    };

    filteredPatients: Patient[] = [];

    onDateChange = (startDate: string, endDate: string): void => {
        const t1 = moment(startDate);
        const t2 = moment(endDate);
        if (t1.isValid() && t2.isValid()) {
            this.setState(
                {
                    dates: [t1, t2] as [Moment, Moment],
                    mode: 'custom-followup',
                },
                () => {
                    this.onModeChange('custom-followup');
                },
            );
        }
    };

    onRadioOptionChange = (mode: ListMode): void => {
        if (mode !== 'custom-followup') {
            this.onModeChange(mode);
            return;
        }

        const { dates } = this.state;
        if (dates && dates.filter(Boolean).length === 2) {
            this.onModeChange(mode);
        }
    };

    onAbhaRadioOptionChange = (type?: 'present' | 'absent'): void => {
        this.setState({
            abhaFilterType: type,
        });
    };

    onRefferedRadioOptionChange = (type?: 'referred'): void => {
        this.setState({
            referredFilterType: type,
        });
    };

    followUpFilter = (): ReactNode => (
        <div>
            <Radio.Group
                onChange={(e) => this.onRadioOptionChange(e.target.value)}
                value={this.state.mode}
            >
                <Space direction="vertical">
                    <Radio value={'y-followup'}>Yesterday</Radio>
                    <Radio value={'t-followup'}>Today</Radio>
                    <Radio value={'custom-followup'}>
                        <CustomDatePicker
                            dates={this.state.dates}
                            onDatesSelected={this.onDateChange}
                            noOfDays={Number.MAX_SAFE_INTEGER}
                            enableFuture={true}
                        />
                    </Radio>
                </Space>
            </Radio.Group>
        </div>
    );

    followUpTitle = (): ReactNode => {
        return (
            <div className="flex justify-between w-full items-center">
                <div className="font-400 text-14 bold">Filter</div>
                <Button type="link" onClick={() => this.onModeChange('quick')}>
                    Clear
                </Button>
            </div>
        );
    };

    exportAsExcel = (): void => {
        this.props.dispatch(downloadPtDir());
    };

    onMount = (): void => {
        const clinics = getMyClinics();
        if (clinics?.find((c) => c._id === this.props.match.params.cId)) {
        } else {
            this.props.history.replace(GO_TO_ALL_PATIENTS(getSelectedClinicId() || ''));
        }

        const c = [] as { key: string; label: string }[];

        Promise.all([getPtColumns(), getAddPDForms(), this.onModeChange('quick')])
            .then((values) => {
                [
                    ...MANDATE_PT_COLUMNS,
                    ...values[0].filter((t) => !MANDATE_PT_COLUMNS.includes(t)),
                ].forEach((item) => {
                    if (!this?.props?.isAbdm && item === ABHA_IDS) {
                        return;
                    }

                    if (DEFAULT_PT_COLUMNS.includes(item)) {
                        c.push({ key: item, label: keyToLabel(item) });
                    } else {
                        const df = values[1].find((t) => t.key === item);
                        df && c.push({ key: item, label: df?.label });
                    }
                });

                this.setState(
                    {
                        columns: c,
                        isLoading: false,
                    },
                    fetchPtDir,
                );
            })
            .catch(console.error);

        console.time('dbCallAllPt');
        timeTrackStart('dbCallAllPt');
        indexAllPatients()
            .then((data) => {
                this.patientsFuse = data.patientsFuse;
                this.setState({
                    allPtCount: data.allPtCount,
                    onAppPtsCount: data.onAppPtsCount,
                    abhaPtsNos: data.ptsWithAbha,
                    ptsWithNoLinkedRecords: data.abhaPtsWithNoLinkedRecords,
                });
            })
            .catch(console.error);
    };

    handleAppointmentAction = (ap: APWithOptionalpatient): void => {
        onAppointmentAction(this, ap, this.props.match.params.cId);
    };

    onMergeModalClose = (): void => {
        this.setState((prevMergePtModal) => ({
            mergePtModal: !prevMergePtModal,
        }));

        this.onMount();
    };

    showHealthWeek = (): void => {
        const { dispatch } = this.props;
        dispatch(showDialog('health-week'));
    };

    getFilteredPatients = (allPatients: Patient[]): Patient[] => {
        const { abhaFilterType, referredFilterType } = this.state;

        let tempAllPatients = [...allPatients];

        if (abhaFilterType === 'present') {
            tempAllPatients = allPatients.filter((patient) => !!patient?.abha?.id);
        }

        if (abhaFilterType === 'absent') {
            tempAllPatients = allPatients.filter((patient) => !patient?.abha?.id);
        }

        if (referredFilterType === 'referred') {
            tempAllPatients = tempAllPatients.filter((patient) => patient?.referredBy);
        }

        return tempAllPatients;
    };

    refreshAbhaPatientDetails = async (pid: string): Promise<void> => {
        this.props.history.push(GO_TO_PATIENTS_DETAILS(pid ?? '', 'visit', ''));
    };

    dummyUpdatePatientProfileToRemoveCachedData = async (patient: Patient): Promise<void> => {
        const { dispatch } = this.props;

        if (!patient) {
            track('ERROR', {
                on: 'dummyUpdatePatientProfileToRemoveCachedData => AbhaAllPatient',
                what: 'No patient found',
            });
            return;
        }

        const patientPersonalProfile = patient?.personal;

        const newP = {
            name: [patientPersonalProfile?.name?.f, patientPersonalProfile?.name?.l]
                .filter(Boolean)
                .join(' '),
            phCode: patientPersonalProfile?.phone?.c || '+91',
            phoneNumber: patientPersonalProfile?.phone?.n,
            age: patientPersonalProfile?.age,
            gender: patientPersonalProfile?.gender || '',
            formData: patient?.formData,
        };

        const newPatient = {
            ...newP,
            localId: patient.localId,
            oid: patient.id,
        };

        const onSuccess = async (patient: Patient & { apiFailure: boolean; error?: Error }) => {
            await this.refreshAbhaPatientDetails(patient.id ?? '');
            return;
        };

        dispatch(
            addPatient({
                newPatient,
                sendWelcome: false,
                onSuccess,
            }),
        );

        return;
    };

    setActiveLinkAbhaPatient = (patient?: Patient): void => {
        this.setState({ activeLinkAbhaPatient: patient });
    };

    updateAbhaPt = (pt: Patient): void => {
        this.dummyUpdatePatientProfileToRemoveCachedData(pt);
    };

    gotoAbhaDashBoard = (): void => {
        track('GO_TO_ABHA_DASHBOARD', { from: 'all-patients' });
        this.props.history.push(GO_TO_ABHA_DASHBOARD);
    };

    private queryTodaysAppts() {
        fetchTodayQueue(this.props.match.params.cId)
            .then(async (response: AppointmentsResponse) => {
                if (!response.response?.apt) {
                    return;
                }
                const list = response.response.apt.filter((t) => !isCNRE(t.status));
                const visitIds = list.map((a) => a.aid);
                const localVisits = (await getVisitByIds(visitIds)) || [];
                const localContextList = list.map((a, index) => ({
                    ...a,
                    isLocalPresnt: localVisits[index] !== undefined,
                }));
                this.setState({
                    todayAppointments: localContextList,
                    isApptApiLoading: false,
                });
            })
            .catch((e) => console.log(e));
    }

    onMultiDocBookApt = ({ docId, ptId, clinicId }: MultiDocBookAptHandlerProps): void => {
        this.setState({ bookAptModal: { show: true, docId, ptId, clinicId } });
    };

    onCloseBookAptModal = (): void => {
        this.setState({ bookAptModal: { show: false } });
    };

    handleAppointmentBooking = (apt: Appointment): void => {
        const isSameDay = moment(apt.full_date).isSame(moment(), 'day');
        this.props.history.replace(
            GO_TO_APPOINTMENTS(
                this.props.match.params.cId,
                isSameDay ? 'today-queue' : 'upcoming',
                undefined,
                `date=${moment(apt.full_date).format('YYYY-MM-DD')}&left=booked`,
            ),
        );
    };

    render(): ReactNode {
        const { isHealthWeekDoctorFlag } = this.props;
        const {
            allPatients,
            searchInput,
            isLoading,
            referPt,
            createAbhaPatient,
            tableConfigVisible,
            onAppPtsCount,
            allPtCount,
            mode,
            dates,
            columns,
            mergePtModal,
            abhaFilterType,
            referredFilterType,
            activeLinkAbhaPatient,
            abhaPtsNos,
            ptsWithNoLinkedRecords,
        } = this.state;
        const isHealthWeekDoctor = isHealthWeekDoctorFlag && isDoctor();

        this.filteredPatients = allPatients;

        const clinic = getMyClinics()?.find((c) => c._id === this.props.match.params.cId);
        const tableColumns = columns.filter(
            (item) => item.key !== ABHA_IDS || clinic?.abdm?.hfr_id,
        );

        if (searchInput) {
            // check if it's phone number
            if (!isNaN(parseInt(searchInput.replace('+91', ''))) && searchInput.length > 5) {
                // exact match
                if (searchInput.replace('+91', '').length === 10 && /^\d+$/.test(searchInput)) {
                    this.filteredPatients = this.patientsFuse
                        .search(`=${searchInput}`)
                        .map((option) => option.item);
                } else {
                    this.filteredPatients = this.patientsFuse
                        .search({
                            $and: [
                                { _phone: searchInput.replace('+91', '') }, // Fuzzy "old war"
                            ],
                        })
                        .map((option) => option.item);
                }
            } else if (!isNaN(parseInt(searchInput.replace('+91', ''))) && searchInput.length < 5) {
                this.filteredPatients = this.patientsFuse
                    .search({
                        $and: [
                            { _uhid: `=${searchInput.replace('+91', '')}` }, // Fuzzy "old war"
                        ],
                    })
                    .map((option) => option.item);
            } else {
                this.filteredPatients = [];
            }

            const allPtIds = new Set(this.filteredPatients.map((t) => t.localId));

            this.patientsFuse
                .search(searchInput.replace('+91', ''), { limit: 100 })
                .forEach((option) => {
                    if (!allPtIds.has(option.item.localId)) {
                        this.filteredPatients.push(option.item);
                    }
                });
        }

        return (
            <div
                onClick={this.closeAllDialogs}
                className="flex flex-col w-screen h-full bg-white font-lato select-none"
            >
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - All Patients</title>
                </Helmet>
                <AnimatePresence>
                    {referPt && (
                        <DoctorReferralAllPatient
                            ptId={referPt.id || referPt.localId}
                            close={this.closeReferalDialog}
                            ptName={getPtFullName(referPt)}
                            docid={getDoctorSelectorList()?.[0].id}
                        />
                    )}
                    {createAbhaPatient && (
                        <CreateABHAModalSDK
                            onClose={() => this.onCreateABHA(undefined)}
                            oid={createAbhaPatient.localId}
                            mobile={createAbhaPatient.personal?.phone?.n}
                            onComplete={() => this.updateAbhaPt(createAbhaPatient)}
                            method={'create_abha_with_mobile'}
                        />
                    )}
                    {mergePtModal && <MergeProfileDialog onClose={this.onMergeModalClose} />}{' '}
                    <SlotModal
                        show={this.state.bookAptModal.show}
                        clinicId={this.state.bookAptModal.clinicId}
                        docId={this.state.bookAptModal.docId}
                        ptId={this.state.bookAptModal.ptId}
                        onClose={this.onCloseBookAptModal}
                        handleAppointmentBooking={this.handleAppointmentBooking}
                    />
                </AnimatePresence>

                <div className="grid grid-cols-queueGrid h-full min-w-840 overflow-x-auto">
                    <LeftBar />

                    <div className="flex col-span-11 flex-col">
                        <NewHeaderComponent
                            title={`Patients${getPtCount() ? ` (${getPtCount()})` : ''}`}
                            filterComponent={
                                <div className="flex w-full justify-between gap-8">
                                    <ClinicSelector
                                        onClinicSelect={(selectedClinicId) => {
                                            setSelectedClinicId(selectedClinicId);
                                            this.props.history.replace(
                                                GO_TO_ALL_PATIENTS(selectedClinicId),
                                            );
                                        }}
                                    />
                                    <div className="flex flex-shrink-0 justify-end items-center gap-8">
                                        <div className="flex h-36 border gap-8 border-neutral-6 rounded-8 items-center justify-between px-16 py-6 leading-5 bg-transparent">
                                            <svg
                                                width="17"
                                                height="16"
                                                viewBox="0 0 17 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M15.75 14.7188C16.0625 15.0312 16.0625 15.5 15.75 15.7812C15.625 15.9375 15.4375 16 15.25 16C15.0312 16 14.8438 15.9375 14.6875 15.7812L10.5 11.5938C9.375 12.5 7.96875 13 6.46875 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.875 0 6.46875 0C10.0312 0 12.9688 2.9375 12.9688 6.5C12.9688 8.03125 12.4688 9.4375 11.5625 10.5312L15.75 14.7188ZM1.5 6.5C1.5 9.28125 3.71875 11.5 6.5 11.5C9.25 11.5 11.5 9.28125 11.5 6.5C11.5 3.75 9.25 1.5 6.5 1.5C3.71875 1.5 1.5 3.75 1.5 6.5Z"
                                                    fill="#767676"
                                                />
                                            </svg>

                                            <input
                                                id={ALL_PATIENTS_INPUT_FIELD}
                                                type="search"
                                                className="bg-transparent w-200 lg:w-auto focus:outline-none placeholder-neutral-5 text-14"
                                                name="ether-search-component"
                                                autoComplete="off"
                                                placeholder="Search by UHID / Phone / Name"
                                                value={searchInput}
                                                onChange={(e) =>
                                                    this.onSearchChange(e.target.value)
                                                }
                                            />
                                        </div>

                                        <GoToAddPatientBt
                                            clinicId={this.props.match.params.cId}
                                            newDesign={true}
                                        />
                                    </div>
                                </div>
                            }
                        />
                        {/* <div className="mt-8 mx-8">
                            <PurchaseEkaCreditsStrip />
                        </div> */}
                        <NewSignInStrip />
                        <div className="flex justify-between h-full">
                            <div
                                className={`flex flex-col flex-grow ${
                                    isHealthWeekDoctor ? 'space-y-8' : 'space-y-20'
                                } overflow-hidden`}
                            >
                                <div
                                    className="flex items-center w-full text-status-info py-6 px-18 select-none body-1 w-50p"
                                    style={{
                                        background:
                                            'linear-gradient(100deg, rgb(233 239 255) 2.51%, rgb(255 255 255) 100%)',
                                    }}
                                >
                                    <p className="font-400 text-13 gap-4 flex items-center">
                                        <span className="font-700">{onAppPtsCount}</span>{' '}
                                        <span>Patients Connected on Eka.Care app</span>
                                    </p>
                                    {this.props.isAbdm && (
                                        <Fragment>
                                            {DividerIcon(
                                                'mx-12 font-400 text-darwin-neutral_new-200',
                                            )}
                                            <p className="font-400 text-13 gap-4 flex items-center">
                                                <span className="font-700">{abhaPtsNos}</span>{' '}
                                                <span>Patients with ABHA</span>
                                            </p>
                                            {DividerIcon(
                                                'mx-12 font-400 text-darwin-neutral_new-200',
                                            )}
                                            <p className="font-400 text-13 flex gap-4 items-center">
                                                <span className="font-700">
                                                    {ptsWithNoLinkedRecords}
                                                </span>{' '}
                                                <span>Patients with 0 linked records</span>
                                            </p>
                                            {!getDoc()?.profile.professional.businessId && (
                                                <p
                                                    className="font-700 text-13 flex items-center gap-4 cursor-pointer ml-auto"
                                                    onClick={this.gotoAbhaDashBoard}
                                                >
                                                    <span>View ABHA Dashboard</span>
                                                </p>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                                {isHealthWeekDoctor && (
                                    <div className="mx-12" onClick={this.showHealthWeek}>
                                        <HealthWeekStrip />
                                    </div>
                                )}
                                <div className="flex flex-col h-full overflow-hidden relative">
                                    {tableConfigVisible && (
                                        <TableConfigDialog close={this.closeTableConfig} />
                                    )}

                                    <div className="flex flex-1 flex-auto flex-col items-start absolute inset-0 overflow-y-hidden overflow-x-hidden px-12 pb-16">
                                        {isLoading ? (
                                            <div className="w-full">
                                                <LoadingView />
                                            </div>
                                        ) : allPatients.length === 0 && mode === 'quick' ? (
                                            <AllPatientsEmptyView></AllPatientsEmptyView>
                                        ) : (
                                            <Fragment>
                                                <AllPtTableHeader
                                                    columns={tableColumns}
                                                    mode={mode}
                                                    openTableConfig={this.openTableConfig}
                                                    onRadioOptionChange={this.onRadioOptionChange}
                                                    dates={dates}
                                                    onDateChange={this.onDateChange}
                                                    onModeChange={this.onModeChange}
                                                    onAbhaOptionChange={
                                                        this.onAbhaRadioOptionChange
                                                    }
                                                    onRefferedRadioOptionChange={
                                                        this.onRefferedRadioOptionChange
                                                    }
                                                    abhaFilterType={abhaFilterType}
                                                    referredFilterType={referredFilterType}
                                                />
                                                {allPatients.length === 0 ? (
                                                    <div className="flex flex-col items-center justify-center w-full h-full">
                                                        No patients found with the selected filter{' '}
                                                        <Button
                                                            type="link"
                                                            onClick={() =>
                                                                this.onModeChange('quick')
                                                            }
                                                        >
                                                            Clear filter
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <AllPatientList
                                                        cId={this.props.match.params.cId}
                                                        patients={this.getFilteredPatients(
                                                            searchInput
                                                                ? this.filteredPatients
                                                                : allPatients,
                                                        )}
                                                        columns={tableColumns}
                                                        todayAppointments={
                                                            this.state.todayAppointments || []
                                                        }
                                                        onPatientsDetails={this.onPatientsDetails}
                                                        tDate={this.tDate}
                                                        startVisit={this.startVisit}
                                                        onReferADoc={this.onReferADoc}
                                                        onCreateABHA={this.onCreateABHA}
                                                        onSendReceipt={this.onSendReceipt}
                                                        onArchivePatient={this.onArchivePatient}
                                                        onAppointmentAction={
                                                            this.handleAppointmentAction
                                                        }
                                                        activeLinkAbhaPatient={
                                                            activeLinkAbhaPatient
                                                        }
                                                        setActiveLinkAbhaPatient={
                                                            this.setActiveLinkAbhaPatient
                                                        }
                                                        onAbhaLink={this.updateAbhaPt}
                                                        onMultiDocBookApt={this.onMultiDocBookApt}
                                                    />
                                                )}
                                                {!searchInput && allPtCount && (
                                                    <div className="flex justify-end mt-16 w-full">
                                                        <Button
                                                            type="default"
                                                            onClick={() =>
                                                                this.setState(
                                                                    (prevMergePtModal) => ({
                                                                        mergePtModal: !prevMergePtModal[
                                                                            'mergePtModal'
                                                                        ],
                                                                    }),
                                                                )
                                                            }
                                                            className={`mr-16 ${getAclViewClassName(
                                                                SREV2.MERGE_PATIENTS,
                                                            )}`}
                                                        >
                                                            Merge Profiles
                                                        </Button>
                                                        <Button
                                                            type="default"
                                                            onClick={() =>
                                                                this.onModeChange(
                                                                    mode === 'full'
                                                                        ? 'quick'
                                                                        : 'full',
                                                                )
                                                            }
                                                        >
                                                            {mode === 'full'
                                                                ? 'Show Less'
                                                                : `Show all ${allPtCount} patients`}
                                                        </Button>
                                                    </div>
                                                )}
                                            </Fragment>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="flex flex-col mt-16 space-y-24 overflow-hidden mb-30 select-none"
                                style={{ maxWidth: '27%' }}
                            >
                                <div className="mx-16">
                                    {/* <GoToAddPatientBt clinicId={this.props.match.params.cId} /> */}
                                    <DashboardInviteCodePanel
                                        key={this.state.refreshDocProfile}
                                        downloadExcel={this.exportAsExcel}
                                    />
                                </div>
                                <div
                                    id="whats-new"
                                    style={{ flex: '2 0 0%' }}
                                    className="flex flex-col border border-neutral-7 rounded-4 overflow-auto items-center justify-center"
                                >
                                    <iframe
                                        src={this.announcementUrl}
                                        sandbox="allow-same-origin allow-scripts allow-top-navigation allow-popups allow-forms allow-popups-to-escape-sandbox"
                                        style={{
                                            border: '0px',
                                            outline: '0px',
                                            width: '360px',
                                            height: '100%',
                                        }}
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <PageBottomPopover className="bottom-0" /> */}
            </div>
        );
    }
}

const MAX_COLUMN_ALLOWED = 5;

const TableConfigDialog: React.FC<{
    close: (columns?: GeniePtColumns) => void;
}> = ({ close }) => {
    const dispatch = useDispatch();
    const isAbdm = useSelector((state: GlobalState) => getGenieSetting(state, 'abdm'));

    const [list, setList] = useState(
        [
            ...MANDATE_PT_COLUMNS,
            ...DEFAULT_PT_COLUMNS.filter((t) => !MANDATE_PT_COLUMNS.includes(t)),
        ].map((k) => ({
            key: k,
            label: keyToLabel(k),
        })),
    );
    const [selectedColumns, setSelectedColumns] = useState<GeniePtColumns>([]);

    useEffect(() => {
        getPtColumns()
            .then((values) =>
                setSelectedColumns(
                    Array.from(
                        new Set(
                            [...MANDATE_PT_COLUMNS, ...values]?.filter((key) =>
                                !isAbdm && key === ABHA_IDS ? false : true,
                            ),
                        ),
                    ),
                ),
            )
            .catch(console.error);

        getAddPDForms()
            .then((dForm) => {
                const list2 = list;
                dForm.forEach((d) => {
                    d.key !== 'uhid' &&
                        d.key !== 'salutation' &&
                        list2.push({ key: d.key, label: d.label });
                });

                const newList =
                    list2?.filter((d) => {
                        if (!isAbdm && d.key === ABHA_IDS) {
                            return false;
                        } else {
                            return true;
                        }
                    }) || [];
                setList([...newList]);
            })
            .catch(console.error);
    }, []);

    const isMaxRached = selectedColumns.length > MAX_COLUMN_ALLOWED - 1;

    const toggle = (key: string) => {
        track('TOGGLE_PT_COLUMNS', { key });
        if (selectedColumns.includes(key)) {
            if (MANDATE_PT_COLUMNS.includes(key)) {
                return;
            }
            setSelectedColumns(selectedColumns.filter((i) => i !== key));
        } else {
            if (isMaxRached) {
                track('MAX_PT_COLUMNS_REACHED', { key });
                return;
            }
            setSelectedColumns([...selectedColumns, key]);
        }
    };

    const apply = (): void => {
        dispatch(updatePtColumns(selectedColumns));
        close(selectedColumns);
        track('UPDATE_PT_COLUMNS');
        return;
    };

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            className="top-44 right-12 absolute z-10 flex flex-col bg-white max-h-2/3 w-30p rounded-8 shadow-tight-4 peak-queue-select-action"
        >
            <div>
                <div className="flex items-center justify-between px-16  py-10">
                    <p className="space-x-4 text-neutral-black font-700">
                        Column Settings{' '}
                        <span className="text-11">
                            ({selectedColumns.length}/{MAX_COLUMN_ALLOWED})
                        </span>
                    </p>
                    <div
                        onClick={() => close()}
                        className="flex items-center justify-center w-16 h-16 cursor-pointer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                            className="w-16 h-16 fill-neutral-5 hover:fill-neutral-black"
                        >
                            <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <div className="flex-1 p-16 space-y-8 overflow-auto border-t border-b border-neutral-7">
                {list.map((item) => {
                    const isSelected = selectedColumns.includes(item.key);
                    return (
                        <div
                            key={item.key}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();

                                toggle(item.key);
                            }}
                            className="flex items-center justify-between px-8 py-4 bg-actionPrimary bg-opacity-10 rounded-4 cursor-pointer"
                        >
                            <span
                                className={`${
                                    isMaxRached && !isSelected ? 'text-neutral-4' : 'text-neutral-1'
                                }  text-13 font-700`}
                            >
                                {item.label}
                            </span>
                            <div className="flex items-center justify-center w-16 h-16">
                                {isSelected ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className={`w-16 h-16 ${
                                            MANDATE_PT_COLUMNS.includes(item.key)
                                                ? ''
                                                : 'fill-actionPrimary'
                                        }`}
                                        fill={MANDATE_PT_COLUMNS.includes(item.key) ? 'gray' : ''}
                                    >
                                        <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-16 h-16 fill-neutral-5"
                                    >
                                        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"></path>
                                    </svg>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div>
                <div className="flex items-center justify-end px-16 py-10 border-b border-neutral-7">
                    <button onClick={apply} className="px-12 py-8 primary-btn btn--small">
                        Apply Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: GlobalState) => {
    return {
        refreshAllPatients: state.session.refreshPage,
        isHealthWeekDoctorFlag: state.session.isHealthWeekDoctor,
        isAbdm: state.session['abdm'],
        isMilestonesEnabled: state.session.showMilestone,
    };
};

export default connect(mapStateToProps)(AllPatientsComponent);
export { AllPatientsComponent };
